import { resolveRouter } from './router';
import { resolveStore } from './store';
import { tplLib } from './templateLib';

export async function loadTemplate(userType, code, tpl, mode) {
  const tplModule = tplLib[tpl];
  if (!tplModule) {
    throw new Error(`模板不存在：${tpl}`);
  }
  let i18nIns;
  if (tplModule.i18n) {
    const { loadLanguageAsync, i18n } = await tplModule.i18n();
    i18nIns = i18n;
    await loadLanguageAsync('zh');
  }
  const router = await resolveRouter(userType, code, tpl, mode);
  const store = await resolveStore(userType, code, tpl, mode);
  return { router, store, i18n: i18nIns };
}
